module.exports = __webpack_public_path__ + "static/media/HEART-3.ba924297.svg";